module.exports = __webpack_public_path__ + "afcb88cfb19c4725667ad5cc1bc9a0df.pdf";